var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 52C61.1046 52 62 52.8954 62 54C62 55.1046 61.1046 56 60 56H4C2.89543 56 2 55.1046 2 54C2 52.8954 2.89543 52 4 52H60Z",
    fill: "#7681FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 54V10H10V54C10 55.1046 9.10457 56 8 56C6.89543 56 6 55.1046 6 54V10C6 8.93913 6.42173 7.92202 7.17188 7.17188C7.92202 6.42173 8.93913 6 10 6H34C35.0609 6 36.078 6.42173 36.8281 7.17188C37.5783 7.92202 38 8.93914 38 10V54C38 55.1046 37.1046 56 36 56C34.8954 56 34 55.1046 34 54Z",
    fill: "#7681FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54V26H36C34.8954 26 34 25.1046 34 24C34 22.8954 34.8954 22 36 22H54C55.0609 22 56.078 22.4217 56.8281 23.1719C57.5783 23.922 58 24.9391 58 26V54C58 55.1046 57.1046 56 56 56C54.8954 56 54 55.1046 54 54Z",
    fill: "#7681FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16C25.1046 16 26 16.8954 26 18C26 19.1046 25.1046 20 24 20H16C14.8954 20 14 19.1046 14 18C14 16.8954 14.8954 16 16 16H24Z",
    fill: "#7681FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32C29.1046 32 30 32.8954 30 34C30 35.1046 29.1046 36 28 36H20C18.8954 36 18 35.1046 18 34C18 32.8954 18.8954 32 20 32H28Z",
    fill: "#7681FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42C25.1046 42 26 42.8954 26 44C26 45.1046 25.1046 46 24 46H16C14.8954 46 14 45.1046 14 44C14 42.8954 14.8954 42 16 42H24Z",
    fill: "#7681FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42C49.1046 42 50 42.8954 50 44C50 45.1046 49.1046 46 48 46H44C42.8954 46 42 45.1046 42 44C42 42.8954 42.8954 42 44 42H48Z",
    fill: "#7681FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32C49.1046 32 50 32.8954 50 34C50 35.1046 49.1046 36 48 36H44C42.8954 36 42 35.1046 42 34C42 32.8954 42.8954 32 44 32H48Z",
    fill: "#7681FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsIcon);
export default __webpack_public_path__ + "static/media/buildings-icon.eb3a05ada73d24207d3214096dd9b0c5.svg";
export { ForwardRef as ReactComponent };